<template>
  <RCard
    class="implementations relative-position"
    :class="{ 'has-form': implementation && implementation.custom_form }"
  >
    <Grid v-if="subscriptionPeriods.length" gtc="175px 1fr auto" gap="var(--r-space-xl)" class="full-height">
      <PeriodsSidebar
        :periods="subscriptionPeriods"
        :active-id="implementation ? implementation.id : null"
        @period-changed="getImplementation"
      />

      <div class="content">
        <CustomFormRenderer
          v-if="implementation"
          :key="implementation.id"
          :form="implementation.custom_form"
          class="custom-form-rerender"
          @input="implementation.custom_form = $event"
        >
          <template #no-form>
            <Grid
              justify-content="center"
              align-items="center"
              align-content="center"
              justify-items="center"
              class="full-height"
            >
              <NoData />
              <span>There are no forms created yet</span>
              <RBtn type="link" :to="{ name: 'forms' }">Create custom form</RBtn>
            </Grid>
          </template>
        </CustomFormRenderer>
      </div>

      <Grid gaf="column" gap="var(--r-space-md)" class="actions">
        <template v-if="implementation && implementation.custom_form">
          <RBtn v-if="!implementation.finalized" size="small" type="tertiary" @click="updateImplementation(true)">
            Finalize
          </RBtn>

          <RBtn size="small" type="primary" @click="updateImplementation(false)">Save</RBtn>
        </template>
      </Grid>
    </Grid>

    <QInnerLoading :showing="!subscriptionPeriods.length || requestInProgress">
      <QSpinnerHourglass size="3.5rem" color="primary-1" />
    </QInnerLoading>
  </RCard>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import { mapGetters } from 'vuex'
// Components
import CustomFormRenderer from '@components/lm-blocks/CustomFormRenderer'
import NoData from '@/reusable/svg-icons/NoData'
import PeriodsSidebar from '@/modules/show-page-subscription/shared/PeriodsSidebar'

export default {
  components: {
    CustomFormRenderer,
    NoData,
    PeriodsSidebar
  },

  props: {
    id: [Number, String] // from route
  },

  data: () => ({
    requestInProgress: false,
    implementation: null
  }),

  computed: {
    ...mapGetters('subscription-show', ['subscriptionPeriods'])
  },

  watch: {
    subscriptionPeriods: {
      immediate: true,
      handler(newVal) {
        if (newVal.length) this.getImplementation(newVal[0].id)
      }
    }
  },

  methods: {
    getImplementation(periodId) {
      if (this.requestInProgress) return
      if (this.implementation?.id === periodId) return // if we try to load the same implementation don't do anything

      this.requestInProgress = true

      apiTo
        .GET_SUBSCRIPTION_PERIOD_IMPLEMENTATION(periodId)
        .then(({ data }) => (this.implementation = data.result))
        .finally(() => (this.requestInProgress = false))
    },

    updateImplementation(finalized) {
      if (this.requestInProgress) return

      this.requestInProgress = true

      apiTo
        .UPDATE_SUBSCRIPTION_PERIOD_IMPLEMENTATION(this.implementation.id, {
          content: this.implementation.custom_form.content,
          form_id: this.implementation.custom_form.form_id,
          finalized
        })
        .then(({ data }) => (this.implementation = data.result))
        .finally(() => (this.requestInProgress = false))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.implementations {
  &.has-form {
    @include custom-scrollbar('.content');
    .content {
      overflow: auto;

      .custom-form-rerender {
        height: 0 !important;
        min-height: 400px;
      }
    }
  }
}
</style>
